import React, { useState, useEffect } from 'react';
import { apis } from '../../services/Api';
import { getToken, isLogin } from '../../services/Auth';
import { connect } from 'react-redux';
import { addSkill, addUser, addNotifications, addNotificationsCount, addCourses } from '../../actions/SkillAction';
import { getParameterByName } from '../../common/GetParameterByName/GetParameterByName';
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom";
// import badge1 from '../../assets/images/badge1.svg';
// import badge2 from '../../assets/images/badge2.svg';
import CalendarBlock from '../../common/calendar/calendar';
import CarouselBlock from '../../common/slider/slider';
import './homestyle.css';

function HomeContainer(props) {
    let [enrollmentCount, setEnrollmentCount] = useState("-");
    let [courseCount, setCourseCount] = useState("-");
    let [loDetails, setLoDetails] = useState([]);
    let [recommendationList, setRecommendationList] = useState([]);
    let [recLoDetails, setRecLoDetails] = useState([]);
    let [badgesList, setBadgesList] = useState([]);
    let [badgeInfo, setBadgeInfo] = useState([]);
    const location = useLocation();
    const history = useHistory();


    const getNotifications = async () => {
        if (isLogin()) {
            try {
                let notifyArray = [], notifyCount = 0;
                let { data } = await apis.getUserNotifications(getToken().user_id);
                props.addNotifications(data);
                for (let i = 0; i < data.length; i++) {
                    //increase counter for unread notification
                    if (!data[i].attributes.read) notifyCount += 1;
                    let message = data[i].attributes.message;
                    //remove all { & } from string
                    message = message.replace(/[{}]/g, "");
                    //replace string like name0, name1, name2 with modelNames
                    for (let y = 0; y < data[i].attributes.modelNames.length; y++) {
                        message = message.replace("name" + y, `<strong> ${data[i].attributes.modelNames[y]} </strong>`);
                    }
                    notifyArray.push(message);
                }
                props.addNotificationsCount(notifyCount);
                // setNotificationList(notifyArray);
            } catch (error) {
                //console.log(error);
            }
        }
    }
    //
    const getUser = async () => {
        let { data } = await apis.getUser();
        //console.log(data);
        props.addUser(data);
    }
    //This function gets the details for my learnings
    async function getLoContents() {
        let { data, included } = await apis.getEnrollments();
        //Create an array to contain all courses information to display
        let loContent = [];

        for (let i = 0; i < data.length; i++) {
            for (let j = 0; j < included.length; j++) {
                if ((included[j].type === "learningObject") && (included[j].id === data[i].relationships.learningObject.data.id)) {
                    // pusing the course information to array
                    loContent.push({
                        id: included[j].id,
                        loName: included[j].attributes.localizedMetadata[0].name,
                        imageUrl: included[j].attributes.imageUrl,
                        duration: included[j].attributes.duration,
                        loFormat: included[j].attributes.loFormat,
                        progress: data[i].attributes.progressPercent,
                        skill: included[i].relationships.skills.data[0].id.split('_')[1]
                    });
                }

            }
        }
        setLoDetails(loContent);
    }

    //This function gets the details for recommended courses
    async function getRecommendedLo() {
        let { data, included } = await apis.getRecommendations();
        setRecommendationList(data);

        let recLoContent = [];

        for (let i = 0; i < data.length; i++) {
            for (let j = 0; j < included.length; j++) {
                if ((data[i].type === "recommendation") && (included[j].id === data[i].relationships.learningObject.data.id)) {
                    recLoContent.push({
                        id: included[j].id,
                        loCategory: data[i].type,
                        loName: included[j].attributes.localizedMetadata[0].name,
                        imageUrl: included[j].attributes.imageUrl,
                        duration: included[j].attributes.duration,
                        loType: included[j].attributes.loFormat,
                        rating: included[j].attributes.rating.averageRating,
                        instancesId: included[j].relationships.instances.data[0].id,
                        enrollment: included[j].relationships.enrollment,
                        skill: included[i].relationships.skills.data[0].id.split('_')[1]
                    });
                }
            }
        }
        setRecLoDetails(recLoContent);
    }

    const getBadges = async (userId) => {
        let { data, included } = await apis.getBadges(userId);
        setBadgesList(data);

        let badgeInfoList = [];

        for (let i = 0; i < data.length; i++) {
            for (let j = 0; j < included.length; j++) {
                if (data[i].relationships.badge.data.id === included[j].id) {
                    badgeInfoList.push({
                        badgeId: data[i].relationships.badge.data.id,
                        dateAchieved: data[i].attributes.dateAchieved,
                        imageUrl: included[j].attributes.imageUrl,
                        name: included[j].attributes.name,
                    });
                    break;
                }
            }
        }
        setBadgeInfo(badgeInfoList);
    }

    const getSkill = async (limit, offset) => {

        let { links, data } = await apis.getSkills(limit, offset);
        for (let i = 0; i < data.length; i++) {
            props.addSkill({
                id: data[i].id,
                name: data[i].attributes.name
            });
        }
        if (!links.next) {
            //console.log("all skill is fetched!");
        } else {
            const nextOffset = getParameterByName('page[offset]', links.next);
            getSkill(10, nextOffset);
        }
    }

    const totalCourses = async (limit, cursor, courseList = []) => {
        let { links, data } = await apis.getLearningObjects(limit, cursor);
        let tempCount = 0;
        courseList = [...courseList, ...data];
        for (let i = 0; i < data.length; i++) {
            // setCourseCount(oldData => oldData + 1);
            tempCount += 1;
        }
        if (!links.next) {
            //console.log("all course is fetched!");
            props.addCourses(courseList);
            return tempCount;
        } else {
            const urlParams = new URLSearchParams(links.next);
            const nextCursor = urlParams.get('page[cursor]');
            return tempCount + await totalCourses(10, nextCursor, courseList);
        }
    }

    const totalMyLearningCount = async (limit, cursor) => {
        let { data, links } = await apis.getEnrollments(limit, cursor);
        let tempCount = 0;
        for (let i = 0; i < data.length; i++) {
            // setCourseCount(oldData => oldData + 1);
            tempCount += 1;
        }
        if (!links.next) {
            //console.log("all course is fetched!");
            return tempCount;
        } else {
            const urlParams = new URLSearchParams(links.next);
            const nextCursor = urlParams.get('page[cursor]');
            return tempCount + await totalMyLearningCount(10, nextCursor);
        }
    }

    const initApiCall = async () => {
        try {
            // await accessToken();
            await getUser();
            await getNotifications();
            await getSkill(10, 0);
            await getLoContents();
            await getRecommendedLo();
            await getBadges(getToken().user_id);
            setEnrollmentCount(await totalMyLearningCount(10));
            setCourseCount(await totalCourses(10));
            setInterval(async () => {
                await getNotifications();
            }, 10000);
        } catch (error) {
            //console.log(error);
        }
    }

    useEffect(() => {
        initApiCall();
    }, []);


    const playCourse = (cid, mid) => {
        props.history.push({
            pathname: `/course-player`,
            state: {
                cid,
                mid,
                goBackUrl: location.pathname
            }
        });
    }

    const enrollToCourse = async (cid, ciid) => {
        await apis.setEnrollment(cid, ciid);
        playCourse(cid);
    }

    const dateTimeToDate = (e) => {
        let d = new Date(e);
        const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        let date = ((d.getDate() + " " + monthNames[(d.getMonth())] + " " + d.getFullYear()));
        return date;
    }

    const goToMyLearnings = () => {
        history.push({
            pathname: `/my-learning`
        });
    }

    return (
        <React.Fragment>
            <div className='main-block'>
                <div className='container'>
                    <div className='row mob-courses'>
                        <div className='col'>
                            <div className='courses-count'>
                                <div className='courses-txt'>
                                    <span> {courseCount} </span>
                                    <span className='separator'></span>
                                    <span>Total Courses</span>
                                </div>
                            </div>
                            <div className='learnings-count'>
                                <div className='courses-txt'>
                                    <span> {enrollmentCount} </span>
                                    <span className='separator'></span>
                                    <span>My Learnings</span>
                                </div>
                            </div>
                        </div>
                        <div className='col'>
                            <div className='Badges-card'>
                                <div className='title-block'>
                                    <span className='title'> Latest Badges </span>
                                    <span className='small-separator'></span>
                                    <a className='link' href='/'>View all ({badgesList.length})</a>
                                </div>
                                <div className='badges-img-txt'>
                                    {badgeInfo?.map((e, i) =>
                                        <div className='badges-block' key={i}>
                                            <img src={e.imageUrl} alt='...' />
                                            <div>
                                                {e.dateAchieved ?
                                                    <div className='badges-txt'>
                                                        <div className='badges-title'>Star Learner</div>
                                                        <span>Received on </span>
                                                        <span>{dateTimeToDate(e.dateAchieved)}</span>
                                                    </div>
                                                    :
                                                    <div className='badges-txt'>
                                                        <div className='badges-title'>Course completion</div>
                                                        <span>In Progress</span>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className='col'>
                            <div className='clander-block'>
                                <CalendarBlock />
                            </div>
                        </div>
                        <div className='Carousel-block'>
                            <div className='title-block'>
                                <span className='title'> My Learnings </span>
                                <span className='small-separator'></span>
                                <a className='link cp' onClick={() => goToMyLearnings()}>View all ({enrollmentCount})</a>
                            </div>
                            <CarouselBlock myLearningObj={loDetails} playCourse={playCourse} />
                        </div>
                        <div className='Carousel-block'>
                            <div className='title-block'>
                                <span className='title'>Recommended by Harbinger</span>
                                <span className='small-separator'></span>
                                <a className='link' href='/'>View all ({recommendationList.length})</a>
                            </div>
                            <CarouselBlock myRecLearningObj={recLoDetails} playCourse={playCourse} enrollToCourse={enrollToCourse} />
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}
const mapStateToProps = state => {
    return {
        skills: state.skills
    }
}

const mapDispatchToProps = dispatch => {
    return {
        addSkill: (data) => dispatch(addSkill(data)),
        addUser: (data) => dispatch(addUser(data)),
        addNotifications: (data) => dispatch(addNotifications(data)),
        addNotificationsCount: (data) => dispatch(addNotificationsCount(data)),
        addCourses: (data) => dispatch(addCourses(data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(HomeContainer);